<template>
  <div class="grid-view">

    <div class="main-content">
      <div class="app-main-inner-row">
        <div class="filters">
          <el-form :inline="true" label-width="80px" label-position="left" @submit.native.prevent>
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('SystemMaintenance.MappingType')">
                <cargo-advance-select
                  filterable
                  :headers="[$t('SystemMaintenance.Description')]"
                  :fields="['typeDesc']"
                  :callback-params="{key:'type'}"
                  callback-method-type="value"
                  :default-value="searchConditions.type"
                  tag-value="typeCode"
                  tag-name="typeDesc"
                  :filter-tag-names="['typeDesc']"
                  :static-options="mappingTypeList"
                  style="width:205px;"
                  @parentCallBack="getValueFromChild(searchConditions,$event)"
                />
              </el-form-item>
              <el-form-item :label="$t('SystemMaintenance.Condition')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.static_data_Company"
                  :callback-params="{key:'condition1'}"
                  callback-method-type="value"
                  :default-value="searchConditions.condition1"
                  :static-options="companyList"
                  style="width:205px;"
                  @parentCallBack="getValueFromChild(searchConditions,$event)"
                />
              </el-form-item>
              <el-form-item :label="$t('SystemMaintenance.SendingPlatform')">
                <cargo-advance-select
                  filterable
                  :callback-params="{key:'sendingPlatform'}"
                  callback-method-type="value"
                  :default-value="searchConditions.sendingPlatform"
                  :static-options="sendingPlatformList"
                  tag-name="chineseName"
                  tag-value="code"
                  style="width:205px;"
                  @parentCallBack="getValueFromChild(searchConditions,$event)"
                />
              </el-form-item>
              <el-form-item label-width="0">
                <el-checkbox v-if="currentOfficeId !== 1" v-model="isViewHQMapping" @change="onViewHQMappingChange">{{ $t('SystemMaintenance.ViewHQMapping') }}</el-checkbox>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="triggers">
          <el-button type="primary" size="mini" @click="toQuery">
            {{ $t('common.btn.query') }}
          </el-button>
          <el-button type="primary" size="mini" @click="popMappingAddDialog">{{
            $t('common.btn.new') }}
          </el-button>
          <el-button type="primary" size="mini" @click="popMappingEditFormDialog">{{
            $t('common.btn.edit') }}
          </el-button>
          <el-button type="danger" size="mini" @click="toBatchDel">{{
            $t('common.btn.delete') }}
          </el-button>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="20220821"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-options="gridOptions"
          :side-bar="sideBarDefs"
          style="width: 100%;"
          @gridReady="onReady"
        />
      </div>
      <div>
        <cargo-pagination
          config-module="20220821"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchData"
        />
      </div>
    </div>
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="isShowDialogForm"
      :title="dialogTitle"
      inline-message
      width="405px"
    >
      <el-form
        ref="mappingForm"
        :model="mappingForm"
        label-width="120px"
        label-position="right"
      >
        <el-form-item :label="$t('SystemMaintenance.MappingType')">
          <cargo-advance-select
            filterable
            :headers="[$t('SystemMaintenance.Description')]"
            :fields="['typeDesc']"
            :callback-params="{key:'type'}"
            callback-method-type="value"
            :default-value="mappingForm.type"
            tag-value="typeCode"
            tag-name="typeDesc"
            :filter-tag-names="['typeDesc']"
            :static-options="mappingTypeList"
            style="width:205px;"
            @parentCallBack="getValueFromChild(mappingForm,$event)"
          />
        </el-form-item>
        <el-form-item :label="$t('SystemMaintenance.Condition')">
          <cargo-advance-select
            filterable
            :headers="[$t('SystemMaintenance.EnglishName2'),$t('SystemMaintenance.ChineseName2')]"
            :fields="['englishName','chineseName']"
            :callback-params="{key:'condition1'}"
            callback-method-type="value"
            :default-value="mappingForm.condition1||''"
            tag-value="cmpIdx"
            tag-name="chineseName"
            :filter-tag-names="['englishName','chineseName','code']"
            :static-options="companyList"
            style="width:205px;"
            @parentCallBack="getValueFromChild(mappingForm,$event)"
          />
        </el-form-item>
        <el-form-item :label="$t('SystemMaintenance.SendingPlatform')">
          <cargo-advance-select
            filterable
            :multiple="true"
            :placeholder="' '"
            callback-method-type="value"
            :static-options="sendingPlatformList"
            :default-multiple-value="mappingForm.sendingPlatformList"
            tag-name="chineseName"
            tag-value="code"
            style="width:205px;"
            @parentCallBack="value=>mappingForm.sendingPlatformList=[...value]"
          />
        </el-form-item>
        <el-form-item v-if="mappingForm.type === 'BOOKING_STATUS'" :label="$t('CargoMsg.Cargo_CarrierShip')">
          <el-input v-model="mappingForm.carrier" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('SystemMaintenance.OriginalValue')">
          <el-input v-model="mappingForm.sourceValue" size="mini" />
        </el-form-item>
        <el-form-item v-if="mappingForm.type === 'BOOKING_STATUS'" :label="$t('SystemMaintenance.NewValue')">
          <cargo-advance-select
            filterable
            :static-options="SystemConstants.JOB_BOOKING_STATES_NEW"
            :default-value="!!mappingForm.targetValue ? Number(mappingForm.targetValue) : 0"
            tag-name="chineseName"
            tag-value="code"
            @parentCallBack="p=>mappingForm.targetValue=p.value"
          />
        </el-form-item>
        <el-form-item v-else :label="$t('SystemMaintenance.NewValue')">
          <el-input v-model="mappingForm.targetValue" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('SystemMaintenance.Remark')">
          <el-input v-model="mappingForm.remarks" type="textarea" rows="2" size="mini" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini " type="primary" @click="submit">{{ $t('common.btn.save') }}</el-button>
        <el-button size="mini " @click="isShowDialogForm=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { getMappingListByPage, getMappingTypeList, getMappingDetail, delMapping, saveMapping } from '@/api/sysManage/baseConfig/mappingManage'
import { Assert } from '@/utils/validate'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getFilterCacheList } from '@/utils/basicDataCache'
import { cache, cacheName } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'

export default {
  name: 'MappingManagement',
  components: {

    cargoAdvanceSelect
  },
  data() {
    return {
      SystemConstants,
      selectTypeNames: TYPE_NAMES,
      loading: null,
      companyList: [],
      sendingPlatformList: [],
      mappingTypeList: [],
      columnDefs: [
        {
          headerName: this.$t('SystemMaintenance.MappingType'),
          field: 'type',
          colId: 'type',
          cellRenderer: (params) => {
            const mapping = this.mappingTypeList.find(item => {
              return item.typeCode === params.value
            })
            return mapping ? mapping.typeDesc : params.value
          }
        }, {
          headerName: this.$t('SystemMaintenance.Condition'),
          field: 'condition1',
          colId: 'condition1',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SystemMaintenance.OriginalValue'),
          field: 'sourceValue',
          colId: 'sourceValue'
        }, {
          headerName: this.$t('SystemMaintenance.NewValue'),
          field: 'targetValue',
          colId: 'targetValue',
          cellRenderer: (params) => {
            if (params.data.type === 'BOOKING_STATUS') {
              return ColumnUtils.jobBookingState(Number(params.value))
            } else {
              return params.value
            }
          },
          filterParams: {},
          filterValueGetter: (params) => {
            if (params.data.type === 'BOOKING_STATUS') {
              return ColumnUtils.jobBookingState(Number(params.data.sourceValue))
            } else {
              return params.data.sourceValue
            }
          }
        }, {
          headerName: this.$t('SystemMaintenance.Remark'),
          field: 'remarks',
          colId: 'remarks'
        }, {
          headerName: this.$t('SystemMaintenance.SendingPlatform'),
          width: 120,
          field: 'sendingPlatform',
          colId: 'sendingPlatform',
          valueFormatter: (params) => {
            return this.sendingPlatformLabelFun(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.BranchCMP'),
          field: 'officeId',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'code')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CarrierShip'),
          field: 'carrier',
          width: 100
        },
        {
          headerName: this.$t(this.$t('CargoMsg.Cargo_OperateBy')),
          field: 'modifiedBy',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t(this.$t('CargoMsg.Cargo_OperateTime')),
          field: 'dateModified',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        paginationNumberFormatter: function(params) {
          return '[' + params.value.toLocaleString() + ']'
        }
      },
      gridApi: null,
      searchConditions: {
        type: '',
        condition1: '',
        sendingPlatform: '',
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      initMappingForm: {
      },
      mappingForm: {
        uuid: '',
        type: '',
        condition1: '',
        sourceValue: '',
        targetValue: '',
        remarks: '',
        sendingPlatform: '',
        sendingPlatformList: [],
        carrier: ''
      },
      isShowDialogForm: false,
      isViewHQMapping: true
    }
  },
  computed: {
    url() {
      return URL
    },
    dialogTitle() {
      if (this.mappingForm.uuid) {
        return this.$t('SystemMaintenance.EditMapping')
      }
      return this.$t('SystemMaintenance.CreateMapping')
    },
    currentOfficeId() {
      return this.$store.getters.currentOfficeId
    },
    isPlatform() {
      return this.$store.getters.tenantId === 1
    }
  },
  watch: {
    currentOfficeId() {
      this.toQuery()
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.initMappingForm = { ...this.mappingForm }
    this.loading = getLoading()
    await getMappingTypeList().then(res => {
      this.mappingTypeList = res.data
    })
    const partnerManagementMode = parseInt(cache.config.get('PartnerManagementMode'))
    this.companyList = await getFilterCacheList(TYPE_NAMES.basic_data_Company, company => {
      if (partnerManagementMode === 1) {
        if (!(company.branchId > 1 && company.branchId === this.$store.getters.currentOfficeId)) {
          return false
        }
      } else {
        if (company.branchId !== 1 && company.branchId !== this.$store.getters.currentOfficeId) {
          return false
        }
      }
      return true
    })
    this.sendingPlatformList = SystemConstants.SENDING_PLATFORMS
    await this.toQuery()
    this.loading.close()
  },
  beforeMount() {
    if (LocalStorageUtilsNew.hasConfiguration('isViewHQMapping')) {
      this.isViewHQMapping = LocalStorageUtilsNew.getConfiguration('isViewHQMapping')
    }
  },
  methods: {
    onReady(params) {
      const self = this
      // params.api.sizeColumnsToFit()
      // self.gridOptions.columnApi = params.api
      this.gridApi = params.api
      window.addEventListener('resize', function() {
        setTimeout(function() {
          // params.api.sizeColumnsToFit()
          self.onFirstDataRendered(self.gridOptions)
        })
      })
    },
    onFirstDataRendered(gridOptions) {
      const allColumnIds = []
      gridOptions.columnApi.getAllColumns().forEach(function(column) {
        allColumnIds.push(column.colId)
      })
      setTimeout(function() {
        gridOptions.columnApi.autoSizeColumns(allColumnIds)
      })
    },
    async toQuery() {
      this.searchConditions.pageNum = 1
      this.searchConditions.total = 0
      this.fetchData()
    },
    async fetchData() {
      this.loading = getLoading()
      const params = { ...this.searchConditions, branchId: this.currentOfficeId }
      if (this.currentOfficeId !== 1) {
        params.viewHQMapping = this.isViewHQMapping
      }
      await getMappingListByPage(params).then((res) => {
        this.rowData = [...res.data.list]
        this.searchConditions.total = res.data.total ? Number(res.data.total) : 0
      }).finally(() => {
        this.loading.close()
      })
    },
    popMappingAddDialog() {
      this.isShowDialogForm = true
      this.mappingForm = { ...this.initMappingForm }
    },
    async popMappingEditFormDialog() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (!selectedRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (!this.isPlatform && selectedRow.officeId !== this.currentOfficeId) {
        this.$message.error(this.$t('SystemMaintenance.BranchNotMatchNotOperate'))
        return
      }
      const mappingRes = await getMappingDetail(selectedRow.uuid)
      this.mappingForm = { ...mappingRes.data }
      if (this.mappingForm.sendingPlatform) {
        const array = this.mappingForm.sendingPlatform.split(',')
        this.mappingForm.sendingPlatformList = array
      }
      // 显示编辑弹窗
      this.isShowDialogForm = true
    },
    async toBatchDel() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (!selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (!this.isPlatform && selectedRow.officeId !== this.currentOfficeId) {
        this.$message.error(this.$t('SystemMaintenance.BranchNotMatchNotOperate'))
        return
      }
      // 表格单选，删除一条
      await this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.confirm'), { type: 'warning' })
      this.loading = getLoading()
      delMapping(selectedRow.uuid).then(async() => {
        await this.fetchData()
      }).finally(() => {
        this.loading.close()
      })
    },
    sendingPlatformLabelFun(item) {
      let text = ''
      if (item && item.sendingPlatform) {
        const array = item.sendingPlatform.split(',')
        const isZh = this.$store.getters.language === 'zh'
        for (const key of array) {
          const commonState = SystemConstants.getCommonState(key, SystemConstants.SENDING_PLATFORMS)
          if (commonState != null) {
            if (isZh) {
              if (text) {
                text = text + ',' + commonState.chineseName
              } else {
                text = commonState.chineseName
              }
            } else {
              if (text) {
                text = text + ',' + commonState.englishName
              } else {
                text = commonState.englishName
              }
            }
          }
        }
      }
      return text
    },
    getValueFromChild(model, obj) {
      const oldValue = model[obj.key]
      model[obj.key] = obj.value
      if (obj.key === 'type' && this.mappingForm && oldValue === 'BOOKING_STATUS' && this.mappingForm.type !== 'BOOKING_STATUS') {
        this.mappingForm.carrier = ''
        this.mappingForm.targetValue = ''
      }
    },
    // 检查新建映射、编辑映射表单
    async toCheckForm() {
      const { type, sourceValue, targetValue } = { ...this.mappingForm }
      await Assert.isNotBlank(type, this.$t('SystemMaintenance.PleaseEnterMappingType'))
      await Assert.isNotBlank(sourceValue, this.$t('SystemMaintenance.PleaseEnterTheOriginalValue'))
      await Assert.isNotBlank(targetValue, this.$t('SystemMaintenance.PleaseEnterTheNewValue'))
    },
    async submit() {
      await this.toCheckForm()
      this.loading = getLoading()
      this.mappingForm.officeId = this.currentOfficeId
      if (this.mappingForm.sendingPlatformList) {
        let text = ''
        for (const data of this.mappingForm.sendingPlatformList) {
          if (text.length !== 0) {
            text = text + ','
          }
          text = text + data
        }
        this.mappingForm.sendingPlatform = text
      } else {
        this.mappingForm.sendingPlatform = ''
      }
      saveMapping(this.mappingForm, this.mappingForm.uuid).then(async() => {
        this.isShowDialogForm = false
        await this.fetchData()
      }).finally(() => {
        this.loading.close()
      })
    },
    onViewHQMappingChange() {
      LocalStorageUtilsNew.setConfiguration('isViewHQMapping', this.isViewHQMapping)
      this.toQuery()
    }
  }
}
</script>

<style scoped>

</style>
